export class AddressesUrlParams {
  static LOGIN: string = "login";  
  static PAGES_HOME: string = "home";
  static PAGES_INDEX: string = `index`;
  static PAGE_DONACIONES: string = `donaciones`;     


  /**
   * @author Jose Wilson Mulato
   * @description construye la ruta para ir al index
   */
  static PathIndex() {
    return `${AddressesUrlParams.PAGES_HOME}/${AddressesUrlParams.PAGE_DONACIONES}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/parameters/addresses-url-params.ts